module.exports = __webpack_public_path__ + "media/images/bg/mosaic/camp-fac3155f7ada7c96b73cc3b97336d749.jpg";